export const calculateDays = (firstDate: Date, secondDate: Date): number => {
  const differenceInTime = secondDate.getTime() - firstDate.getTime();
  return Math.abs(Math.floor(differenceInTime / (1000 * 3600 * 24)));
};

export default calculateDays;
